module.exports = __webpack_public_path__ + "static/media/40_tn.974b0c79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/40_tn.jpg
// module id = 676
// module chunks = 0